import React, { useState } from 'react'
import logo from '@/assets/image/logo.svg'
import { useTranslation } from 'react-i18next'
import { Dropdown, MenuProps } from 'antd'
import { ArrowRightOutlined, CaretDownOutlined } from '@ant-design/icons'
import usePersistDataStore from '@/stores/persistData'
import { useNavigate } from 'react-router-dom'
import personalReg from '@/assets/image/personalReg.png'
import businessReg from '@/assets/image/businessReg.png'
import RegForm from './components/RegForm'

const Register: React.FC = () => {
  const { t } = useTranslation()
  const lang = usePersistDataStore(state => state.lang)
  const setLang = usePersistDataStore(state => state.setLang)
  const navigate = useNavigate()
  const [registType, setRegistType] = useState('')

  const languageList: MenuProps['items'] = [
    { key: 'en_US', label: 'English', onClick: () => setLang('en_US') },
    { key: 'zh_CN', label: '中文', onClick: () => setLang('zh_CN') },
  ]

  return (
    <div className='login'>
      <div className='login-header'>
        <div className='register-header-left'>
          <img src={logo} />
          <div className='register-separator'></div>
          <div className='register-title'>{t('user.registration')}</div>
        </div>
        <div className='login-header-right'>
          <div className='register-header-right-tip'>{t('user.registerHeaderTip')}</div>
          <div className='register-header-loginbtn' onClick={() => navigate('/login')}>
            {t('user.login')}
          </div>
          <div className='header-separator'></div>
          <Dropdown menu={{ items: languageList }} placement='bottom'>
            <div className='login-header-right-language'>
              <span>{lang === 'en_US' ? 'English' : '简体中文'}</span>
              <CaretDownOutlined />
            </div>
          </Dropdown>
        </div>
      </div>
      <div className='reg-content'>
        {registType === '' ? (
          <>
            <div className='type-card' onClick={() => setRegistType('personal')}>
              <img className='type-card-img' src={personalReg} />
              <div className='type-card-right'>
                <div className='type-card-right-title'>{t('user.personalRegTitle')}</div>
                <div className='type-card-right-tip'>{t('user.personalRegTip')}</div>
              </div>
              <div className='type-card-tobtn'>
                <ArrowRightOutlined />
              </div>
            </div>
            <div className='type-card' onClick={() => setRegistType('business')}>
              <img className='type-card-img' src={businessReg} />
              <div className='type-card-right'>
                <div className='type-card-right-title'>{t('user.businessRegTitle')}</div>
                <div className='type-card-right-tip'>{t('user.businessRegTip')}</div>
              </div>
              <div className='type-card-tobtn'>
                <ArrowRightOutlined />
              </div>
            </div>
          </>
        ) : (
          <RegForm registrantType={registType} onClickBack={() => setRegistType('')} />
        )}
      </div>
    </div>
  )
}

export default Register
